import { AppSettings } from './app.settings';
export class BasketSettings{
    public static GET_BASKET = `${AppSettings.BASE_URL}/api/transaction/transactionSales`;
    public static DELETE_BASKET = `${AppSettings.BASE_URL}/api/transaction/removeSaleFromTransaction`;
    public static APPLY_COUPON = `${AppSettings.BASE_URL}/api/coupon/applyCoupon`;
}